/* ••[1]••••••••••••••••••••••••• TestimonialVideoController.ts •••••••••••••••••••••••••••••• */

/* ••[2]•••••••••• Components ••••••••••••••• */
import CCCTestimonialVideo from "../components/testimonial-video/testimonialVideo";

/* ••[2]•••••••••• Models ••••••••••••••• */
import TestimonialVideoModel from "./../models/TestimonialVideoModel";

/* ••[2]•••••••••• Types ••••••••••••••• */
import { TestimonialVideo } from "../core/types/TestimonialVideo";
// import EventModel from "../models/EventModel";
import { CCCPanel } from "../components/panel/panel";

export default class TestimonialVideoController {
  private $anchor: HTMLElement | null = null;
  private CCCTestimonialVideoInstance: CCCTestimonialVideo | null;

  constructor(anchor: string) {
    try {
      this.$anchor = document.querySelector(anchor);

      if (!this.$anchor) {
        throw `Testimonial Video - ${anchor} element not found in DOM`;
      }
    } catch (error) {
      console.error(error);
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public get instance(): CCCTestimonialVideo | null {
    return this.CCCTestimonialVideoInstance;
  }

  public async init(): Promise<CCCTestimonialVideo | null> {
    this.CCCTestimonialVideoInstance = new CCCTestimonialVideo();
    const cccPanel: CCCPanel = document.createElement("ccc-panel") as CCCPanel;
    cccPanel.setAttribute("title", "");
    cccPanel.setAttribute("padding-horizontal", "0");
    this.CCCTestimonialVideoInstance.setAttribute("slot", "component");
    cccPanel.append(this.CCCTestimonialVideoInstance);
    this.$anchor.appendChild(cccPanel);
    await this.setData();

    return this.CCCTestimonialVideoInstance;
  }

  private async setData(): Promise<void> {
    if (this.CCCTestimonialVideoInstance) {
      try {
        const testimonialVideos: Array<TestimonialVideo> =
          await TestimonialVideoModel.getTestimonialVideoData();

        this.CCCTestimonialVideoInstance.testimonialVideo =
          testimonialVideos[
            Math.floor(Math.random() * (testimonialVideos.length + 1))
          ];
      } catch (error) {
        return null;
      }
    }
  }
}
